import { toFixed } from '@/utils/numbers';
export const commas = val => {
  let [int, decimal] = val.toString().split('.');
  int = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  decimal = decimal ? '.' + decimal : '';
  return `${int}${decimal}`;
};
export function formatPointsWithUnit(num: number | string, needK = false) {
  if (!num && num !== 0) return '';
  num = Number(num);

  if ((needK && num < 1000) || (!needK && num - 9999999.9 <= 0)) {
    num = toFixed(String(num), 2, 1);
    return formatNumber(num);
  }

  const units = ['K', 'M', 'B', 'T', 'Q', 'Qn', 'S', 'Sp'];
  let unitIndex = -1;

  while (num > 999.9 && unitIndex < units.length - 1) {
    num /= 1000;
    unitIndex++;
  }

  return formatNumber(num) + ' ' + units[unitIndex];
}

export function formatNumber(num: number | string, decimal = 2) {
  return Number(num).toLocaleString(undefined, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal + 2,
  });
}

export function addThousandSeparator(num: number | string) {
  const numStr = num.toString();
  const numStrArr = numStr.split('.');
  const result = `${numStrArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${numStrArr[1] ? `.${numStrArr[1]}` : ''}`;
  return result;
}

// 使用示例
// const address = "0x3a466d8389f0EbacAd11339tB7FA7fAa2ed13b73Dc";
// console.log(abbreviateAddress(address)); // 输出: 0x3A46...3b73Dc
export function abbreviateAddress(address: string): string {
  // // 检查是否以 '0x' 开头
  // if (!address.startsWith('0x')) {
  //   throw new Error('Invalid address format. Address must start with "0x".')
  // }

  // // 移除 '0x' 前缀
  // const addressWithoutPrefix = address.slice(2)

  // 定义显示的字符数（不包括前缀）
  const displayLength = 4;

  // 计算省略号应该出现的位置
  const midIndex = address.length - displayLength;

  // 返回缩略地址
  return `0x${address.substring(0, displayLength)}...${address.substring(midIndex)}`;
}
